import { AuthenticationContainer } from "entities/Authentication";
import { Flex, Loading, Typography } from "shared/_ui";
import styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import { StatusPageProps } from "../../lib/StatusPageProps";

function isTelegramWebApp() {
    // eslint-disable-next-line
    // @ts-ignore
    return typeof TelegramWebviewProxy !== 'undefined';
}

const InProgress: React.FC<StatusPageProps> = ({returnLink}) => {
    const { t } = useTranslation();

    const page_content = 
    <Flex className={styles.wrapper} direction="column" align="center">
        <Loading className={styles.icon} size="large"/>
        <Typography.Title className={styles.heading} level={1}>
            {t('banner.inProgressPayment.heading')}
        </Typography.Title>
    </Flex>

    const web_page = 
    <AuthenticationContainer>
      {page_content}
    </AuthenticationContainer>
    
      const frame_page = <div className={styles.framewrapper}>{page_content}</div>
    
      return (returnLink && !isTelegramWebApp()) ? web_page : frame_page;
}

export { InProgress };